import Button from "./Button";
import bannerImg from "../images/bannerImg.png";
import { Link } from "react-router-dom";
export default function HeroBanner() {
  return (
    <section className="relative mt-16 py-14 z-10" id="hero">
      <div className="flex flex-col lg:flex-row justify-between items-center gap-4 w-full 2xl:w-[80%] 2xl:mx-auto">
        <div className="flex flex-col justify-center items-center lg:items-start lg:w-1/2 px-10 pt-10 lg:pl-20 lg:pr-10 lg:py-20 ">
          <span className="uppercase text-light-orange text-sm lg:text-xl font-semibold mb-2">
            We are the best
          </span>
          <h1 className="text-medium-black font-black uppercase sm:text-xl  md:text-4xl xl:text-4xl text-center lg:text-left mb-3  ">
            Transform your body, <br />
            Transform your life
          </h1>
          <p className="text-md text-light-grey font-normal mb-10 xl:text-xl text-center lg:text-start">
            Seize the opportunity its time to get in the best shape of your life
          </p>
          <div className="flex gap-7 items-center">
            <Link to="/exercise">
              <Button color="light-purple">Browse Exercises</Button>
            </Link>

            <div className="flex gap-2 items-center">
              <p className="font-black text-4xl lg:text-5xl">30</p>
              <p className="text-sm font-normal leading-tight lg:text-lg lg:leading-snug">
                Minutes
                <br />
                per day
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center w-3/4 lg:w-1/2 px-5 py-10 object-cover  ">
          <img src={bannerImg} alt="hero banner" />
        </div>
      </div>
    </section>
  );
}
